namespace GeniuzPOS.ReportMasterData {
    export interface Report_1201_DtForm {
    }

    export class Report_1201_DtForm extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1201_Dt';
    }
}
